/**
 * Tabelas do banco.
 */
export const Tabelas = {
  atuacao: 'atuacao',
  comarca: 'comarca',
  configuracoes: 'configuracoes',
  conselho_superior: 'conselho_superior',
  curso: 'curso',
  defensor: 'defensor',
  defensoria: 'defensoria',
  distrito: 'distrito',
  diretoria: 'diretoria',
  endereco: 'endereco',
  estagiario: 'estagiario',
  estagiario_anexo: 'estagiario_anexo',
  estagio: 'estagio',
  feriado: 'feriado',
  funcao: 'funcao',
  funcao_salario: 'funcao_salario',
  historico: 'historico',
  instituicao_ensino: 'instituicao_ensino',
  lotacao: 'lotacao',
  movimentacao: 'movimentacao',
  movimentacaoregistro: 'movimentacao_registro',
  movimentacaotipo: 'movimentacao_tipo',
  notificacao: 'notificacao',
  nucleo: 'nucleo',
  periodo: 'periodo',
  pessoa: 'pessoa',
  tipo_gasto: 'tipo_gasto',
  gasto: 'gasto',
  predio: 'predio',
  regra: 'regra',
  responsavel: 'responsavel',
  setor: 'setor',
  substituicao: 'substituicao',
  telefone: 'telefone',
  usuario: 'usuario',
  vara: 'vara',
};


export const editRoutes: Record<string, string> = {
  atuacao: '/atuacoes/editar',
  comarca: '/comarcas/editar',
  defensoria: '/defensoria/editar',
  distrito: '/distrito/editar',
  diretoria: '/diretoria/editar',
  feriado: '/feriados/editar',
  funcao: '/funcao/editar',
  instituicao_ensino: '/instituicoes/editar',
  lotacao: '/vinculos/editar',
  movimentacao: '/atividades/editar',
  movimentacaotipo: '/atividades/tipo/editar',
  nucleo: '/nucleo/editar',
  periodo: '/acoes/editar',
  pessoa: '/pessoa/editar',
  tipo_gasto: '/office/tipo-gasto/editar',
  gasto: '/office/gasto/editar',
  predio: '/predio/editar',
  setor: '/setor/editar',
  vara: '/varas/editar',
};


export function getEditLink(tabela: string, registerId: string | number) {
  const r = editRoutes[tabela] ?? '';
  if (r) {
    return `${r}/${registerId}`;
  }
  return null;
}
